import { render, staticRenderFns } from "./PoFeeSettlement.vue?vue&type=template&id=308ce235&scoped=true"
import script from "./PoFeeSettlement.vue?vue&type=script&lang=ts"
export * from "./PoFeeSettlement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ce235",
  null
  
)

export default component.exports